export const ROLES = {
  ADMIN: 'ADMIN',
  PARTNER: 'PARTNER'
};
